'use strict';
import * as $j_app$002edata$002e$002dCertificate$002dOf$002dOrigin$002dGoods$002dEntry from "./app.data.-Certificate-Of-Origin-Goods-Entry.js";
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDescription$002dForm$0024 from "./app.data.data_point_types$package$-Description-Form$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5() {
}
export { $c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 as $c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 };
$p = $c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5;
/** @constructor */
function $h_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5() {
}
export { $h_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 as $h_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 };
$h_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5.prototype = $p;
$p.bYD = (function(src, failFast) {
  var this$1 = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDescription$002dForm$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$().az().bh(src.qF, failFast);
  matchResult12: {
    var $x_1;
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
      var $x_1 = this$1;
      break matchResult12;
    }
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
      var $x_1 = this$1.bo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_PathElement$Accessor("description"));
      break matchResult12;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$1);
  }
  var this$3 = $x_1;
  if ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value(new $j_app$002edata$002e$002dCertificate$002dOf$002dOrigin$002dGoods$002dEntry.$c_Lapp_data_CertificateOfOriginGoodsEntry(this$3.a1, src.og.gy, src.oh.gy, src.pJ, src.qG, src.pK));
  }
  if ((this$3 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
    return this$3;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$3);
});
$p.bh = (function(src, failFast) {
  return this.bYD(src, failFast);
});
var $d_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5, "app.data.CertificateOfOriginGoodsEntryForm$$anon$5", ({
  CL: 1,
  bz: 1,
  by: 1
}));
export { $d_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 as $d_Lapp_data_CertificateOfOriginGoodsEntryForm$$anon$5 };
//# sourceMappingURL=app.data.-Certificate-Of-Origin-Goods-Entry-Form$$anon$5.js.map
